import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { onlineUsers, allPlayerBet } from "../Redux/allPlayersSlice";

function SocketConnection({ username = "admin", level = 0 }) {
	const dispatch = useDispatch();
	const isProduction = 1;
	const ip = "socket.99khelojeeto.in";
	const port = isProduction ? process.env.REACT_APP_SOCKET_PORT : "3080";

	const socketRef = useRef(null);
	const connectingRef = useRef(false);
	const reconnectAttemptsRef = useRef(0);

	const sendMessage = (data) => {
		if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
			socketRef.current.send(JSON.stringify(data));
		} else {
			console.warn("WebSocket is not open. Unable to send message.");
		}
	};

	// ✅ Connect WebSocket when component mounts
	useEffect(() => {
		const connectWebSocket = () => {
			console.log("Trying to connect with socket");
			// Don't reconnect if the socket is already open and roomid hasn’t changed
			if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
				return;
			}

			// Prevent multiple parallel connection attempts
			if (connectingRef.current) {
				return;
			}

			// Close existing socket if socket not open
			if (socketRef.current) {
				socketRef.current.close();
			}

			connectingRef.current = true;

			const socket = new WebSocket(`wss://${ip}?user=${username}&level=${level}`);

			socket.onopen = () => {
				reconnectAttemptsRef.current = 0;
				connectingRef.current = false;
				console.log("Socket connected!");
			};

			socket.onmessage = (event) => {
				const msg = JSON.parse(event.data);

				switch (msg.type) {
					case "onlineUsers":
						dispatch(onlineUsers(msg.users));
						break;

					case "betsUpdate":
						dispatch(allPlayerBet(msg.bets));
						break;

					default:
						break;
				}
			};

			socket.onerror = (err) => {
				console.error("WebSocket error:", err);
				connectingRef.current = false;
			};

			socket.onclose = () => {
				console.warn("WebSocket closed.");
				connectingRef.current = false;
				if (reconnectAttemptsRef.current < 5) {
					reconnectAttemptsRef.current++;
					setTimeout(connectWebSocket, 5000);
				}
			};

			socketRef.current = socket;
		};

		if (username && level !== null) {
			connectWebSocket();
		}

		return () => {
			if (socketRef.current) {
				socketRef.current.close();
			}
		};
	}, [username, level, ip, port]);

	return { sendMessage };
}

export default SocketConnection;
